'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoUpload = function IoUpload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.6 18.2c3.5 0 6.4 2.9 6.4 6.5s-2.9 6.5-6.4 6.5h-8.6v-6.2h3.8l-6.3-6.6-6.2 6.6h3.7v6.3h-8c-3.8 0-7-3.3-7-7.2 0-3.1 2-5.7 4.8-6.7 0.4-2.2 2.2-4 4.6-4 0.8 0 1.4 0.3 2 0.6 1.5-3.1 4.6-5.2 8.2-5.2 5 0 9 4.1 9 9.2v0.2z' })
        )
    );
};

exports.default = IoUpload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/upload.js
// module id = 2519
// module chunks = 0